/**
 * Route for `igaming-scheduled-bi-warehouse-exports-etl`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingScheduledBiWarehouseExportsEtlPage } from "../features/igaming-scheduled-bi-warehouse-exports-etl/IgamingScheduledBiWarehouseExportsEtlPage";

export const igamingScheduledBiWarehouseExportsEtlRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-scheduled-bi-warehouse-exports-etl",
	component: IgamingScheduledBiWarehouseExportsEtlPage,
});

export default igamingScheduledBiWarehouseExportsEtlRoute;
